<template>
  <v-dialog v-model="internalDialog" max-width="900px">
    <v-card>
      <v-card-title class="headline elevation-2 mb-2">
        {{ pdfName }}
      </v-card-title>

      <v-card-text style="height:600px; overflow-y:auto;">
        <div v-if="pages.length === 0" class="text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>

        <div v-for="(page, index) in pages" :key="index" class="mb-4 text-center">
          <canvas :ref="'canvas'+index"></canvas>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="close">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import "pdfjs-dist/build/pdf.worker.entry";

export default {
  name: "PdfViewer",
  props: {
    value: { type: Boolean, required: true }, // v-model
    file: {},
    scale: { type: Number, default: 1.2 } // Zoom
  },

  data() {
    return {
      internalDialog: this.value,
      pdfDoc: null,
      pdfName: "",
      pages: []
    };
  },

  watch: {
    value(v) {
      this.internalDialog = v;
      if (v && this.file) this.loadPdf();
    }
  },

  methods: {
    async loadPdf() {
      const arrayBuffer = await this.file.arrayBuffer();
      this.pdfName = this.file.name
      this.pdfDoc = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      const numPages = this.pdfDoc.numPages;

      this.pages = Array.from({ length: numPages }, (_, i) => i + 1);

      this.$nextTick(() => this.renderAllPages());
    },

    async renderAllPages() {
      for (let i = 0; i < this.pages.length; i++) {
        const page = await this.pdfDoc.getPage(i + 1);
        const viewport = page.getViewport({ scale: this.scale });
        const canvas = this.$refs['canvas'+i][0]; 
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const context = canvas.getContext("2d");

        await page.render({ canvasContext: context, viewport: viewport }).promise;
      }
    },

    close() {
      this.internalDialog = false;
      this.$emit("input", false);
      this.pdfDoc = null;
      this.pages = [];
    }
  }
};
</script>
